import API from './PXComAPI'

export default {
  searchCities ({query, filters, lang}) {
    return API.post('/cities', {search: query, filters, lang})
  },
  searchCountries ({query, lang}) {
    return API.post('/countries', {search: query, lang})
  }
}
